var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-box"},[_c('ul',[_vm._m(0),_c('li',[_c('router-link',{attrs:{"to":"/downLoad"}},[_vm._v("产品下载")])],1)]),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("新手入门")])])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"desc"},[_vm._v("@ 2024 yundesktop Inc. 重庆顿硕科技发展有限公司 All rights reserved. "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank"}},[_vm._v("渝ICP备2023010842号")])])
}]

export { render, staticRenderFns }